import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { TranslationService } from '@sdbn/common';
import { Station } from 'src/tmc-yard/client/model/station';
import { PendingTaskState } from 'src/tmc-yard/widgets/control/transport-list/model';
import { PlannedTransport } from '../../../model/sac-client.model';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';

@Component({
  selector: 'app-sac-station-tablet-planned-assignments',
  templateUrl: './sac-station-tablet-planned-assignments.component.html',
  styleUrls: ['./sac-station-tablet-planned-assignments.component.scss']
})
export class SACStationTabletPlannedAssignmentsComponent implements OnInit, OnDestroy {

  @Input() station: Station;

  selectedId: number;

  PendingTaskState = PendingTaskState;

  defaultVisibleColumns = [
    'hint', 'carrier', 'supplier', 'identifier', 'driver', 'visitStatusDict', 'string1', 'string2', 'start', 'reference', 'options', 'cargo', 'planningDate', 'messagingResources', 'filler'
  ];

  columnsToDisplay = this.defaultVisibleColumns;

  dataSource = new MatTableDataSource(new Array<PlannedTransport>());

  refreshSubscription: Subscription;

  constructor(
    public translationService: TranslationService,
    private tmcContextService: TmcContextService,
    private httpService: HttpService
  ) { }

  ngOnInit(): void {

    if (this.refreshSubscription != null) {
      this.refreshSubscription.unsubscribe();
    }
    this.refreshSubscription = this.tmcContextService.stationUsagesUpdated$.subscribe(
      () => this.loadPlannedTransports()
    );

    this.loadPlannedTransports();

  }

  ngOnDestroy() {
    if (this.refreshSubscription != null) {
      this.refreshSubscription.unsubscribe();
      this.refreshSubscription = null;
    }
  }

  loadPlannedTransports() {

    this.httpService.postWithContext<any[]>(`${environment.sacClientEndpoint}/find-planned-transports-for-station`, { id: this.station.id }).subscribe(
      plannedTransports => {

        let data = new Array<PlannedTransport>();

        for (const plannedTransport of plannedTransports) {
          data.push(new PlannedTransport(plannedTransport));
        }

        this.dataSource = new MatTableDataSource(data);

      }
    );

  }

}
